// pragma: allowlist secret
import React from "react";
import { Auth } from "aws-amplify";
import { SignIn } from "aws-amplify-react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Link } from "react-router-dom";
import ResetPassword from "./ResetPassword.js";
import SignUp from "./SignUp.js";
import EVLogo from "../assets/FPLEVolutionLogo_Horizontal_LeftJustified_2925.png";
import "../style/login.css";
import background from "../assets/loginbackground.png";
import Header from "./Header.js";

const DialogTheme = createTheme({
  palette: {
    primary: {
      main: "#009fda",
    },
    secondary: {
      main: "#009fda",
    },
  },
  overrides: {
    MuiDialog: {
      container: {
        maxWidth: "75vw",
      },
    },
    MuiInput: {
      input: {
        color: "#3E3E3E !important",
      },
      underline: {
        color: "#3E3E3E !important",
      },
    },
    MuiInputLabel: {
      root: {
        color: "#3E3E3E !important",
      },
    },
  },
});

class LoginScreen extends SignIn {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "", // pragma: allowlist secret
      externalUser: false,
      user: "",
      newPassword: "", // pragma: allowlist secret
      newConfirmPassword: "", // pragma: allowlist secret
      newPasswordDialog: false,
      showPassword: false,
      errorMessage: false,
    };
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
  }

  signInExternal = (e) => {
    if ((e && e.key === "Enter") || !e) {
      Auth.signIn(this.state.username, this.state.password)
        .then((user) => {
          this.setState(
            {
              user: user,
              externalUser: false,
              newPasswordDialog: false,
              errorMessage: false,
            },
            () => {
              if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                this.setState({
                  externalUser: false,
                  newPasswordDialog: true,
                });
              } else {
                super.changeState("signedIn");
              }
            }
          );
        })
        .catch((err) => {
          this.setState({ errorMessage: true });
        });
    }
  };

  handleClose = () => {
    this.setState({ externalUser: false });
  };

  handleExternal = () => {
    this.setState({ externalUser: true });
  };

  handleUserChange = (text) => {
    this.setState({
      username: text.target.value,
    });
  };

  handlePWChange = (text) => {
    this.setState({
      password: text.target.value, // pragma: allowlist secret
    });
  };

  handleNewPWClose = () => {
    this.setState({
      newPasswordDialog: false,
    });
  };

  handleNewPassword = (text) => {
    // pragma: allowlist secret
    this.setState({
      newPassword: text.target.value, // pragma: allowlist secret
    });
  };

  handleConfirmNewPassword = (text) => {
    // pragma: allowlist secret
    this.setState({
      newConfirmPassword: text.target.value, // pragma: allowlist secret
    });
  };

  handleTempPassword = () => {
    // pragma: allowlist secret
    if (this.state.newPassword !== this.state.newConfirmPassword) {
      // pragma: allowlist secret
      alert("New passwords do not match - please re-enter");
    } else {
      Auth.completeNewPassword(this.state.user, this.state.newPassword)
        .then((user) => {
          Auth.signIn(this.state.username, this.state.newPassword);
        })
        .then((user) => {
          this.setState(
            {
              user: user,
              externalUser: false,
              newPasswordDialog: false,
            },
            () => {
              super.changeState("signedIn");
            }
          );
        });
    }
  };

  handleClickShowPassword = () =>
    this.setState({ showPassword: !this.state.showPassword });

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  showComponent(theme) {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <Header auth={false} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundImage: `url(${background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                //width: "100vw",
                height: "100vh",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: "104px" }}
              >
                <span style={{ color: "#ffffff", fontSize: "21px" }}>
                  Welcome to the FPL EVolution®
                </span>
                <span
                  style={{
                    color: "#ffffff",
                    fontSize: "36px",
                    fontWeight: "bold",
                  }}
                >
                  Site Host Dashboard
                </span>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                style={{
                  backgroundColor: "#ffffff",
                  width: "30%",
                  marginTop: 20,
                  left: "50%",
                  padding: 23,
                  borderRadius: 4,
                }}
              >
                <span
                  style={{
                    color: "#404040",
                    fontWeight: "bold",
                  }}
                >
                  Log In
                </span>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{
                      width: "70%",
                      marginTop: "30px",
                      marginBottom: "40px",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      autoFocus
                      margin="dense"
                      fullWidth={true}
                      id="username"
                      label="Email Address"
                      type="email"
                      InputLabelProps={{
                        shrink: true,
                        style: {
                          fontSize: ".8rem",
                        },
                      }}
                      inputProps={{
                        style: {
                          fontSize: ".85rem",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => this.setState({ username: "" })}
                              edge="end"
                              size="small"
                            >
                              <CancelIcon
                                className="eyeIcon"
                                fontSize="small"
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={this.state.username}
                      onChange={(text) => this.handleUserChange(text)}
                      onKeyPress={(e) => this.signInExternal(e)}
                    />
                    <div style={{ marginTop: 10 }} />
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth={true}
                      id="password"
                      label="Password"
                      type={this.state.showPassword ? "email" : "password"}
                      InputLabelProps={{
                        shrink: true,
                        style: {
                          fontSize: ".8rem",
                        },
                      }}
                      inputProps={{
                        style: {
                          fontSize: ".85rem",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                              edge="end"
                              size="small"
                            >
                              {this.state.showPassword ? (
                                <VisibilityOff
                                  className="eyeIcon"
                                  fontSize="small"
                                />
                              ) : (
                                <Visibility
                                  className="eyeIcon"
                                  fontSize="small"
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={this.state.password}
                      onChange={(text) => this.handlePWChange(text)}
                      onKeyPress={(e) => this.signInExternal(e)}
                      helperText="Username or password incorrect"
                      FormHelperTextProps={{
                        style: {
                          color: "red",
                          fontSize: 12,
                          display: this.state.errorMessage ? "flex" : "none",
                        },
                      }}
                    />
                  </Box>
                  <Button
                    className="button-text"
                    style={{
                      color: "#ffffff",
                      fontSize: 15,
                      fontWeight: "bold",
                      borderColor: "white",
                      height: 42,
                      width: 227,
                      borderRadius: 4,
                      marginTop: 0,
                      backgroundColor: "#0073a8",
                      marginBottom: 20,
                    }}
                    onClick={() => this.signInExternal()}
                  >
                    LOG IN
                  </Button>
                  <Box className="blueTouchableContainer">
                    <Link
                      to="/login/reset"
                      style={{ all: "unset", margin: "auto", marginLeft: "0" }}
                    >
                      <Typography className="blueTouchableText">
                        FORGOT PASSWORD?
                      </Typography>
                    </Link>
                  </Box>
                  <div
                    style={{
                      marginTop: 25,
                      marginBottom: 25,
                      width: "90%",
                      height: 1,
                      backgroundColor: "#666666",
                      opacity: 0.3,
                    }}
                  />
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <span
                      style={{
                        color: "#404040",
                        fontWeight: "bold",
                        fontSize: 14,
                        marginRight: 5,
                      }}
                    >
                      Don't have an account?
                    </span>
                    <Link to="/signup" style={{ all: "unset", margin: "auto" }}>
                      <div
                        className="blueTouchableContainer"
                        onClick={this.handleExternal}
                      >
                        <span className="blueTouchableText">Register Now</span>
                      </div>
                    </Link>
                  </Box>
                </Box>
              </Box>
              <ThemeProvider theme={DialogTheme}>
                <Dialog
                  open={this.state.newPasswordDialog}
                  onClose={this.handleNewPWClose}
                  aria-labelledby="form-dialog-title"
                  style={{
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    alignSelf: "center",
                    justifyContent: "center",
                  }}
                >
                  <DialogTitle id="pw-dialog-title" class="h2-changePass">
                    Change Your Password
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="newpw"
                      label="New Password"
                      type="password"
                      fullWidth
                      value={this.state.newPassword}
                      onChange={(text) => this.handleNewPassword(text)}
                    />
                    <TextField
                      margin="dense"
                      id="confirmnewpw"
                      label="Confirm New Password"
                      type="password"
                      fullWidth
                      value={this.state.newConfirmPassword}
                      onChange={(text) => this.handleConfirmNewPassword(text)}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleNewPWClose} color="primary">
                      Cancel
                    </Button>
                    <Button onClick={this.handleTempPassword} color="primary">
                      Sign In
                    </Button>
                  </DialogActions>
                </Dialog>
              </ThemeProvider>
            </div>
          </Route>
          <Route path="/login/reset">
            <ResetPassword />
          </Route>
          <Route path="/signup">
            <SignUp />
          </Route>
          <Route path="*">
            <Redirect path="/" />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default LoginScreen;
